exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone {\n  width: 100%;\n  border: 1px dashed #cfd2d8;\n  border-radius: 3px;\n}\n\n.hotel-name {\n  color: blue;\n}\n\ni {\n  margin-right: .25rem;\n}\n\n.hotel-image {\n  width: 60px;\n  height: 50px;\n}\n\n.line:nth-child(2n+1) {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.clickable:hover {\n  box-shadow: 0px 0px 3px 2px rgba(0, 0, 255, 0.2);\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  cursor: not-allowed !important;\n}\n\n.btn-primary {\n  height: 30px;\n  margin-left: 10px;\n  line-height: 15px;\n  margin-top: -5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/system-hotels/system-hotels.component.css
// module id = ../../../../../src/app/main/pages/system-hotels/system-hotels.component.css
// module chunks = main